<template>
  <div id="anli">
    <div class="h5" style="padding-top: 50px;">
      <div class="banner">
        <img src="../../static/image/alzx.png" alt />
      </div>
      <div class="table">
        <Tabs active-key="key1" @on-click="change_click">
          <Tab-pane label="移动端" key="0">
            <ul class="m_video" v-cloak>
              <li
                v-for="(item,i) in video_list"
                :key="i"
                :style="{'background':'url('+item.video_pic+')no-repeat center ','background-size':'100% 100%'}"
                @click="play_video(item.video_url)"
              >
                <div class="video_name">{{item.example_name}}</div>
                <img src="../../static/image/start.png" alt class="start" />
              </li>
            </ul>
          </Tab-pane>
          <Tab-pane label="PC端" key="1">
            <ul class="pc_video" v-cloak>
              <li
                v-for="(item,i) in video_list"
                :key="i"
                :style="{'background':'url('+item.video_pic+')no-repeat  center ','background-size':'100% 100%'}"
                @click="play_video(item.video_url)"
              >
                <div class="video_name">{{item.example_name}}</div>
                <img src="../../static/image/start.png" alt class="start" />
              </li>
            </ul>
          </Tab-pane>
        </Tabs>
        <Page
          :total="total"
          show-elevator
          style="display:flex; justify-content: center;"
          @on-change="page_change"
          :page-size="formdata.length"
        ></Page>
      </div>
      <xfck></xfck>
    </div>
    <div class="msk" v-if="is_play">
      <div class="msk_conteter" :style="{'width':screenWidth/1.92+'px','height':screenHidth/1.64+'px'}">
        <img src="../../static/image/gb.png" alt class="gb" @click="Shut_down" />
        <video :src="video_url" autoplay="autoplay" style="width:100%;height:100%" controls="controls"></video>
      </div>
    </div>
  </div>
</template>
<script>
import xfck from "./xfck.vue";
export default {
  name: "htmls",
  data() {
    return {
      formdata: {
        start: "0",
        length: 8,
        order_by: "add_time",
        order_dir: "desc",
        example_type: 1
      },
      is_play: false,
      total: 0,
      video_list: [],
      video_url: "",
      screenWidth:'',
      screenHidth:''
    };
  },
  components: {
    xfck
  },
  created() {
    this.get_video();
    this.getShowClient()
  },
  methods: {
    //获取屏幕的宽高
    getShowClient(){
      this.screenWidth=window.screen.width
      this.screenHidth =window.screen.height
      console.log(this.screenHidth)
    },
    change_click(key) {
      if (key === 0) {
        key = 1;
      } else {
        key = 0;
      }
      this.formdata.example_type = key;
      this.get_video();
      this.video_list = null;
      this.formdata.length = 9;
    },
    get_video() {
      var that = this;
      var url =
        that.baseUrl + "/jianyun/api/mall.php?c=example_case/getExampleList";
      that.axios
        .get(url, {
          params: that.formdata
        })
        .then(res => {
          if (res.data.success) {
            that.total = parseInt(res.data.data.recordsTotal);
            if (res.data.data.list.length) {
              res.data.data.list.forEach((item,index) => {
                  if(item.video_pic.indexOf('http')==-1){
                      res.data.data.list[index].video_pic = that.img_url+ item.video_pic
                  }
              });
              that.video_list = res.data.data.list;
            }
          } else {
            this.$Message.warning(res.data.msg);
          }
        })
        .catch(error => {
          // console.log(error);
        });
    },
    page_change(e) {
      this.formdata.start = (e - 1)*10;
    },
    play_video(video_url) {
      this.video_url = video_url;
      this.is_play = true;
    },
    Shut_down() {
      this.is_play = false;
    }
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
#anli .banner {
  width: 100%;
}
#anli .banner > img {
  width: 100%;
  height: 100%;
}
[v-cloak] {
  display: none;
}
#anli .table {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
  min-height: 500px;
}
#anli .ivu-tabs-ink-bar {
  background: rgba(255, 137, 50, 1);
}
#anli .ivu-tabs-nav .ivu-tabs-tab {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: rgba(153, 153, 153, 1);
}
#anli .ivu-tabs-nav .ivu-tabs-tab-active {
  color: rgba(255, 137, 50, 1);
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 300;
}
ul {
  list-style: none;
}
#anli .m_video {
  display: flex;
  flex-wrap: wrap;
}
#anli .m_video li {
  width: 285px;
  height: 507px;
  margin: 10px 5px;
  position: relative;
  cursor: pointer;
  border: 1px solid #000;
}
#anli .pc_video {
  display: flex;
  flex-wrap: wrap;
}
#anli .pc_video li {
  width: 380px;
  height: 250px;
  margin: 10px 10px;
  position: relative;
  cursor: pointer;
  border: 1px solid #000;
}
#anli .m_video li .video_name {
  width: 285px;
  height: 32px;
  background: rgba(0, 0, 0, 0.5);
  text-align: center;
  line-height: 32px;
  color: #fff;
  position: absolute;
  bottom: 0;
}
#anli .pc_video li .video_name {
  width: 380px;
  height: 32px;
  background: rgba(0, 0, 0, 0.5);
  text-align: center;
  line-height: 32px;
  color: #fff;
  position: absolute;
  bottom: 0;
}
#anli li .start {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
#anli .msk {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100000;
}
#anli .msk .msk_conteter {
  background: #000;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
#anli .msk .msk_conteter .gb {
  width: 48px;
  height: 48px;
  position: absolute;
  right: -45px;
  top: -60px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/case.vue